import { render, staticRenderFns } from "./VisitorBlocked.vue?vue&type=template&id=195500ff&scoped=true"
import script from "./VisitorBlocked.vue?vue&type=script&lang=js"
export * from "./VisitorBlocked.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "195500ff",
  null
  
)

export default component.exports